import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { ENTITY_TYPES } from '@sales-center/common'
import React, { useCallback, useState } from 'react'
import FileOpenIcon from '@mui/icons-material/FileOpen'
import { AttachmentsDrawer } from '@user/components/Attachments/AddAttachmentsDrawer'
import { useFormikContext } from 'formik'
import { CreateAgreementFormPacketModel } from './typings'
import { toast } from '@sales-center/components'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export default function AgreementAttachments(props: Props) {
  const { entityId, entityType } = props
  const [open, setOpen] = useState(false)

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [setOpen])
  const {
    setFieldValue,
    values: { templates },
  } = useFormikContext<CreateAgreementFormPacketModel>()
  return (
    <Box
      sx={{
        my: 1.2,
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        color="primary"
        variant="text"
        sx={{
          textTransform: 'none',
          fontWeight: 'medium',
        }}
        onClick={handleOpen}
        data-test-id="agreement-attachments-button"
      >
        <FileOpenIcon
          sx={{
            mr: 1,
            fontSize: '18px',
          }}
        />
        Attach File
      </Button>
      <AttachmentsDrawer
        entityType={entityType}
        entityId={entityId}
        canUpdate={true}
        open={open}
        onClose={handleClose}
        onSelectionComplete={(attachments) => {
          setFieldValue('templates', [...attachments, ...templates])
          toast.success('File(s) successfully added to the agreement.')
        }}
      />
    </Box>
  )
}
